import { ReactNode } from "react";

import {
  INotificationContainerWrapperProps,
  NotificationContainerWrapper,
} from "./styles";

interface INotificationContainerProps
  extends INotificationContainerWrapperProps {
  children: ReactNode;
}

export const NotificationContainer = ({
  children,
  ...rest
}: INotificationContainerProps) => {
  return (
    <NotificationContainerWrapper {...rest}>
      {children}
    </NotificationContainerWrapper>
  );
};
